import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MsalService } from '@azure/msal-angular'
import { AppConfigService } from '../services/app-config.service';
 
@Injectable()
 
    export class CustomIdTokenInterceptor implements HttpInterceptor {
 
        constructor(private msalservice: MsalService, private appConfigService: AppConfigService) {}
 
        intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
            const idToken = this.msalservice.instance.getActiveAccount()?.idToken;
            const IsB2CEnable = this.appConfigService.getConfig().getEnv('IsB2CEnable').toString();
 
            if (idToken && IsB2CEnable !== 'true') {
                const authReq = request.clone({
                    setHeaders: { Authorization: `Bearer ${idToken}`}
                });
                return next.handle(authReq);
            }
            else
            {
                return next.handle(request);
            }
        }
    }